/*
 * Copyright (c) 2021. Dave van Rijn Development
 */
import './style/dvrdSwitch.scss';

import classNames from 'classnames';
import React, {useContext} from 'react';
import {ControlContext} from "../util/controlContext";
import {convertColor} from "../util/colorUtil";

interface Props {
    onChange: (value: boolean, evt: React.MouseEvent) => void;
    value: boolean;
    className?: string;
    disabled?: boolean;
    activeColor?: string;
}

export default function DvrdSwitch(props: Props) {
    const context = useContext(ControlContext),
        {className, onChange, disabled, value, activeColor} = props;

    function onToggle(evt: React.MouseEvent) {
        if (!disabled)
            onChange(!value, evt);
    }

    function getTrackColor(): string {
        let color: string;
        if (disabled) color = 'color-gray-4';
        else if (value) {
            if (activeColor) color = activeColor;
            else color = context.baseColor;
        } else color = 'color-gray-7';
        return convertColor(color);
    }

    function getHandleColor(): string {
        let color: string;
        if (disabled) color = 'color-gray-3';
        else color = context.contrastColor;
        return convertColor(color);
    }

    return (
        <div className={classNames('dvrd-switch', value && 'active', disabled && 'disabled', className)}
             onClick={onToggle}>
            <div className='track' style={{backgroundColor: getTrackColor()}}>
                <div className='handle' style={{backgroundColor: getHandleColor()}}/>
            </div>
        </div>
    )
}